export default {"src":"/_next/static/media/up-accordion.297a82da.svg","height":30,"width":12};